const a = (t) => typeof t == "string" && (t === "lg" || t === "md" || t === "sm" || t === "xs" || t === "2xs" || t === "3xs"), l = (t) => a(t) ? t : "md";
export {
  l as fallbackSize,
  a as validateSize
};
//# sourceMappingURL=highrise.es289.js.map
